import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import './App.css';
import Login from './Pages/Login';
import Home from './Pages/SuperAdmin/Home';
import Admin from './Pages/Admin/Home';
import Header from './Components/Header';
import Sidebar from './Components/Sidebar';
import CreateAdmin from './Pages/SuperAdmin/CreateAdmin';
import ManageUsers from './Pages/SuperAdmin/ManageUsersAdmin';
import DeactivateUsers from './Pages/SuperAdmin/DeactivateUsers';
import Plans from './Pages/SuperAdmin/Plans';
import ActiveUsers from './Pages/SuperAdmin/ActiveUsers';
import CreateUser from './Pages/Admin/CreateUser';
import DeactivePlans from './Pages/SuperAdmin/DeactivePlans';
import Reports from './Pages/SuperAdmin/Reports';
import Forgot from './Pages/Forgot';
import ResetPassword from './Pages/ResetPassword';
import NotFound from './Pages/NotFound';
import ViewFaculty from './Pages/Admin/ViewFaculty';
import ViewStudents from './Pages/Admin/ViewStudents';
import ManageUsersAdmin from './Pages/Admin/ManageUsersAdmin';
import UpdateFaculty from './Pages/Admin/UpdateFaculty';
import AddClassesSubjects from './Pages/Admin/AddClassesSubjects';
import EditclassesSubjects from './Pages/Admin/EditclassesSubjects';
import LeaveRequest from './Pages/Admin/LeaveRequest';
import UpdateStudents from './Pages/Admin/UpdateStudents';
import Student from './Pages/Student/Home';
import Faculty from './Pages/Faculty/Home';
import FacultyAttendance from './Pages/Admin/FacultyAttendance';
import FacultyAttendanceToday from './Pages/Admin/FacultyAttendanceToday';
import ClassAttendance from './Pages/Faculty/ClassAttendance';
import StudentAttendanceHistory from './Pages/Faculty/StudentAttendanceHistory';
import FacultyLeave from './Pages/Faculty/FacultyLeave';
import TodayLeaves from './Pages/Admin/TodayLeaves';
import AllLeaves from './Pages/Admin/AllLeaves';
import FacultyLeaveHistory from './Pages/Faculty/FacultyLeaveHistory';
import StudentClasses from './Pages/Student/Studentclasses';
import ViewStudentAttendance from './Pages/Student/ViewStudentAttendance';
import StudentLeaveApply from './Pages/Student/StudentLeaveApply';
import StudentLeaveHistory from './Pages/Student/StudentLeaveHistory';
import CreateEventsAnnounce from './Pages/Admin/CreateEventsAnnounce';
import ExaminationUpdate from './Pages/Admin/ExaminationUpdate';
import ViewExamination from './Pages/Admin/ViewExamination';
import CancelExams from './Pages/Admin/CancelExams';
import FacultyCreateExamination from './Pages/Faculty/FacultyCreateExamination';
import FacultyViewExamination from './Pages/Faculty/FacultyViewExamination';
import StudentExams from './Pages/Student/StudentExams';
import ViewAnnoucements from './Pages/Admin/ViewAnnoucements';
import FacultyViewAnnouncements from './Pages/Faculty/FacultyViewAnnouncements';
import ManageNotes from './Pages/Admin/ManageNotes';
import ShareNotes from './Pages/Faculty/ShareNotes';
import StudentNotes from './Pages/Student/StudentNotes';
import FacultySupport from './Pages/Faculty/FacultySupport';
import FacultyTicketHistory from './Pages/Faculty/FacultyTicketHistory';
import StudentSupport from './Pages/Student/StudentSupport';
import StudentTicketHistory from './Pages/Student/StudentTicketHistory';
import AdminTicketHistory from './Pages/Admin/AdminTicketHistory';
import AdminSupport from './Pages/Admin/AdminSupport';
import FacultyReport from './Pages/Faculty/FacultyReport';
import ViewReports from './Pages/SuperAdmin/ViewReports';
import StudentReport from './Pages/Student/StudentReport';
import AdminViewReports from './Pages/Admin/AdminViewReports';
import ReportHistory from './Pages/Admin/ReportHistory';
import AdminAttendanceHistory from './Pages/Admin/AdminAttendanceHistory';
import ViewMoreDetails from './Pages/Admin/ViewMoreDetails';
import AttendanceDetails from './Pages/Admin/AttendanceDetails';
import AttendanceDetailsStudent from './Pages/Admin/AttendanceDetailsStudent';
import StudentUploadMark from './Pages/Admin/StudentUploadMark';
import ViewStudentMarks from './Pages/Admin/ViewStudentMarks';
import StudentViewMarks from './Pages/Student/StudentViewMarks';
import Profile from './Components/Profile';
import Footer from './Components/Footer';
import ViewFacultyAttendance from './Pages/Faculty/ViewFacultyAttendance';
import ViewReportsHistory from './Pages/SuperAdmin/ViewReportsHistory';
import ViewExaminationHistory from './Pages/Admin/ViewExaminationHistory';
import GenerateBill from './Pages/Admin/GenerateBill';
import CreateBill from './Pages/Admin/CreateBill';
import AddBillDetails from './Pages/Admin/AddBillDetails';
import ChangePassword from './Components/ChangePassword';
import PrivacyPolicy from './Pages/PrivacyPolicy';
import TermsConditions from './Pages/TermsConditions';
import PaymentRecords from './Pages/Admin/PaymentRecords';
import AdminDetails from './Pages/SuperAdmin/AdminDetails';
import FeeTransaction from './Pages/Student/FeeTransaction';
import AdminStudents from './Pages/SuperAdmin/AdminStudents';
import AdminFaculty from './Pages/SuperAdmin/AdminFaculty';
import HostelService from './Pages/SuperAdmin/HostelService';
import HostelAllotment from './Pages/Admin/HostelAllotment';


function App() {
  return (
    <Router>
      <div className="App">
        <ConditionalLayout />
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/forgot-password" element={<Forgot />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-conditions" element={<TermsConditions />} />
          <Route path="/superadmin" element={<ProtectedRoute component={Home} />} />
          <Route path="/create-Admin" element={<ProtectedRoute component={CreateAdmin} />} />
          <Route path="/Manage-users" element={<ProtectedRoute component={ManageUsers} />} />
          <Route path="/deactivate-users" element={<ProtectedRoute component={DeactivateUsers} />} />
          <Route path="/plans" element={<ProtectedRoute component={Plans} />} />
          <Route path="/de-active-plan" element={<ProtectedRoute component={DeactivePlans} />} />
          <Route path="/active-users" element={<ProtectedRoute component={ActiveUsers} />} />
          <Route path="/create-user" element={<ProtectedRoute component={CreateUser} />} />
          <Route path="/reports" element={<ProtectedRoute component={Reports} />} />
          <Route path="/view-report" element={<ProtectedRoute component={ViewReports} />} />
          <Route path="/view-report-admin-report" element={<ProtectedRoute component={ViewReportsHistory} />} />
          <Route path="/profile" element={<ProtectedRoute component={Profile} />} />
          <Route path="/change-password" element={<ProtectedRoute component={ChangePassword} />} />
          <Route path="/admin-details" element={<ProtectedRoute component={AdminDetails} />} />
          <Route path="/admin/:adminId/students" element={<ProtectedRoute component={AdminStudents} />} />
          <Route path="/admin/:adminId/faculty" element={<ProtectedRoute component={AdminFaculty} />} />
          <Route path="/hostel-service" element={<ProtectedRoute component={HostelService} />} />
          
          



          {/* Admin Routes */}
          <Route path="/admin" element={<ProtectedRoute component={Admin} />} />
          <Route path="/view-faculty" element={<ProtectedRoute component={ViewFaculty} />} />
          <Route path="/view-students" element={<ProtectedRoute component={ViewStudents} />} />
          <Route path="/manage-users-admin" element={<ProtectedRoute component={ManageUsersAdmin} />} />
          <Route path="/update-faculty" element={<ProtectedRoute component={UpdateFaculty} />} />
          <Route path="/update-students" element={<ProtectedRoute component={UpdateStudents} />} />
          <Route path="/Add-classes-subjects" element={<ProtectedRoute component={AddClassesSubjects} />} />
          <Route path="/Edit-classes-subjects" element={<ProtectedRoute component={EditclassesSubjects} />} />
          <Route path="/leave-request" element={<ProtectedRoute component={LeaveRequest} />} />
          <Route path="/faculty-attendance" element={<ProtectedRoute component={FacultyAttendance} />} />
          <Route path="/faculty-attendance-today" element={<ProtectedRoute component={FacultyAttendanceToday} />} />
          <Route path="/faculty-leave-apply" element={<ProtectedRoute component={FacultyLeave} />} />
          <Route path="/today-leave-apply" element={<ProtectedRoute component={TodayLeaves} />} />
          <Route path="/all-leave-history" element={<ProtectedRoute component={AllLeaves} />} />
          <Route path="/create-events-annoucements" element={<ProtectedRoute component={CreateEventsAnnounce} />} />
          <Route path="/examination-update" element={<ProtectedRoute component={ExaminationUpdate} />} />
          <Route path="/view-examination" element={<ProtectedRoute component={ViewExamination} />} />
          <Route path="/view-exam-history" element={<ProtectedRoute component={ViewExaminationHistory} />} />
          <Route path="/view-cancel-examination" element={<ProtectedRoute component={CancelExams} />} />
          <Route path="/view-announcements" element={<ProtectedRoute component={ViewAnnoucements} />} />
          <Route path="/manage-notes" element={<ProtectedRoute component={ManageNotes} />} />
          <Route path="/admin-customer-support" element={<ProtectedRoute component={AdminSupport} />} />
          <Route path="/admin-ticket-history" element={<ProtectedRoute component={AdminTicketHistory} />} />
          <Route path="/admin-view-reports" element={<ProtectedRoute component={AdminViewReports} />} />
          <Route path="/report-history" element={<ProtectedRoute component={ReportHistory} />} />
          <Route path="/attendance-history" element={<ProtectedRoute component={AdminAttendanceHistory} />} />
          <Route path="/attendance-view-more-details" element={<ProtectedRoute component={ViewMoreDetails} />} />
          <Route path="/faculty-attendance-details/:userId" element={<ProtectedRoute component={AttendanceDetails} />} />
          <Route path="/student-attendance-details/:userId" element={<ProtectedRoute component={AttendanceDetailsStudent} />} />
          <Route path="/student-marks-upload" element={<ProtectedRoute component={StudentUploadMark} />} />
          <Route path="/view-student-marks" element={<ProtectedRoute component={ViewStudentMarks} />} />
          {/* payroll */}
          <Route path="/create-bill" element={<ProtectedRoute component={CreateBill} />} />
          <Route path="/generate-bill" element={<ProtectedRoute component={GenerateBill} />} />
          <Route path="/add-bill-details" element={<ProtectedRoute component={AddBillDetails} />} />
          <Route path="/payment-records" element={<ProtectedRoute component={PaymentRecords} />} />

          {/* Hostel Service */}
          <Route path="/hostel-allotments" element={<ProtectedRoute component={HostelAllotment} />} />




          {/* Faculty */}
          <Route path="/faculty" element={<ProtectedRoute component={Faculty} />} />
          <Route path="/class-attendance" element={<ProtectedRoute component={ClassAttendance} />} />
          <Route path="/student-attendance-history" element={<ProtectedRoute component={StudentAttendanceHistory} />} />
          <Route path="/faculty-leaves-history" element={<ProtectedRoute component={FacultyLeaveHistory} />} />
          <Route path="/faculty-create-examination" element={<ProtectedRoute component={FacultyCreateExamination} />} />
          <Route path="/view-student-examination" element={<ProtectedRoute component={FacultyViewExamination} />} />
          <Route path="/view-faculty-announcements" element={<ProtectedRoute component={FacultyViewAnnouncements} />} />
          <Route path="/faculty-share-notes" element={<ProtectedRoute component={ShareNotes} />} />
          <Route path="/customer-support" element={<ProtectedRoute component={FacultySupport} />} />
          <Route path="/faculty-ticket-history" element={<ProtectedRoute component={FacultyTicketHistory} />} />
          <Route path="/faculty-reports" element={<ProtectedRoute component={FacultyReport} />} />
          <Route path="/faculty-attendance-history" element={<ProtectedRoute component={ViewFacultyAttendance} />} />


          {/* Student */}
          <Route path="/student" element={<ProtectedRoute component={Student} />} />
          <Route path="/student-classes-subjects" element={<ProtectedRoute component={StudentClasses} />} />
          <Route path="/view-student-attendance" element={<ProtectedRoute component={ViewStudentAttendance} />} />
          <Route path="/student-leaves-apply" element={<ProtectedRoute component={StudentLeaveApply} />} />
          <Route path="/student-leaves-history" element={<ProtectedRoute component={StudentLeaveHistory} />} />
          <Route path="/student-exams" element={<ProtectedRoute component={StudentExams} />} />
          <Route path="/view-student-announcements" element={<ProtectedRoute component={FacultyViewAnnouncements} />} />
          <Route path="/student-notes" element={<ProtectedRoute component={StudentNotes} />} />
          <Route path="/student-customer-support" element={<ProtectedRoute component={StudentSupport} />} />
          <Route path="/student-ticket-history" element={<ProtectedRoute component={StudentTicketHistory} />} />
          <Route path="/student-reports" element={<ProtectedRoute component={StudentReport} />} />
          <Route path="/student-view-marks" element={<ProtectedRoute component={StudentViewMarks} />} />
          <Route path="/fee-transaction" element={<ProtectedRoute component={FeeTransaction} />} />

          {/* Not Found Route */}
          <Route path="*" element={<NotFound />} />
          {/*<Route path="*" element={<Navigate to="/notfound" />} /> */}
        </Routes>
      </div>
    </Router>
  );
}

// Component for conditional layout (Header + Sidebar)
function ConditionalLayout() {
  const location = useLocation();
  const noLayoutRoutes = ['/', '/forgot-password', '/reset-password', '/notfound', '/privacy-policy', '/terms-conditions'];
  const showLayout = !noLayoutRoutes.includes(location.pathname);
  return showLayout ? (
    <>
      <Header />
      <Sidebar />
      <Footer />
    </>
  ) : null;
}

// Protected route component
function ProtectedRoute({ component: Component }) {
  const authToken = localStorage.getItem('authToken');
  const userRole = localStorage.getItem('userRole');
  if (!authToken || !userRole) {
    return <Navigate to="/" />;
  }
  return <Component />;
}

export default App;
